import { gql } from 'graphql-request';

import {
  ImageCropID,
  ImageCropUUID,
  ImageCropName,
  ImageCropFile,
  ImageCropSize,
  ImageCropCreatedAt,
  ImageCropNanoID
} from '../imageCropsTypes';

export interface FetchImageCropsQueryResponse {
  id: ImageCropID;
  uuid: ImageCropUUID;
  nanoId: ImageCropNanoID;
  name: ImageCropName;
  file: ImageCropFile;
  size: ImageCropSize;
  createdAt: ImageCropCreatedAt;
}

export const FETCH_IMAGE_CROPS_QUERY = gql`
  query ImageCrops(
    $filters: ImageCropsFilters
    $sort: [ImageCropsSortEnum!]
    $limit: Int
    $offset: Int
  ) {
    imageCrops(filters: $filters, sort: $sort, limit: $limit, offset: $offset) {
      nodes {
        id
        uuid
        nanoId
        name
        file
        size
        createdAt
      }
      paginationInfo {
        nextPage
        totalCount
      }
      sql
    }
  }
`;
